export default __webpack_public_path__ + "static/media/img_home_banner.89db2194.png";